export const IS_VISIBLE_LABEL_PROPERTIES = {
  DO_NOT_SHOW: 'DO_NOT_SHOW',
  SHOW_ALL_PROPERTIES: 'SHOW_ALL_PROPERTIES',
  SHOW_ONLY_REPRESENTATIVE_PROPERTIES: 'SHOW_ONLY_REPRESENTATIVE_PROPERTIES'
}
